const NoDataIcon = function NoDataIcon() {
  return (

    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 0C6.72916 0 0 6.72896 0 15C0 23.271 6.72916 30 15 30C23.2708 30 30 23.271 30 15C30 6.72896 23.2708 0 15 0ZM2.64061 15C2.64061 12.0672 3.66957 9.37126 5.38201 7.24959L22.7502 24.6177C20.6289 26.331 17.9328 27.3595 15 27.3595C8.18502 27.3595 2.64061 21.8148 2.64061 15ZM24.6175 22.7504L7.24936 5.38229C9.37109 3.66902 12.0672 2.64054 15 2.64054C21.815 2.64054 27.3594 8.18522 27.3594 15C27.3594 17.9332 26.3304 20.6292 24.6175 22.7504Z" fill="#CACACA" />
    </svg>

  );
};
export default NoDataIcon;
